function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPolygon = function SvgPolygon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 42",
    width: 60,
    height: 42
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 60 0, 30 42",
    style: {
      fill: "#FFFFFF"
    }
  }));
};
export default SvgPolygon;